import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core"
import { LinqsetNode, NODE_SUPERTYPE, NODE_TYPE } from "../../common/linqset-model";
import { NodeService } from "../../model-services/node.service";

export class NodeInsightsTypeData {
    public nodes:LinqsetNode[] = []

    constructor(public superType:NODE_SUPERTYPE, public type:NODE_TYPE, public selected:boolean=false, public comparisonNodeCount?:number, private override?:number) {}

    get number() {return this.override || this.nodes.length}
}

@Component({
    selector: 'app-node-types-insights',
    templateUrl: './node-types-insights.html',
    styleUrls: ['node-types-insights.scss'],
    standalone: false
})
export class NodeTypesInsightsComponent implements OnChanges {
    @Input() typeData:NodeInsightsTypeData[]
    @Input() useEllipse:boolean

    selectedType:NodeInsightsTypeData
    selectedIndex:number

    NODE_SUPERTYPE=NODE_SUPERTYPE

    @Output() selectTypeEvent = new EventEmitter<NodeInsightsTypeData>();

    constructor(public nodeService: NodeService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedType = undefined
        this.selectedIndex = undefined
        
        if (this.typeData) {
            this.typeData.forEach((td, i) => {
                if (td.selected) {
                    this.selectedType = td
                    this.selectedIndex = i
                }
            })
        }
    }

    getName(typeData:NodeInsightsTypeData) {
        // a name too long for its card is ellipsised by the card, with the whole name on hover
        return this.nodeService.getNodeType(typeData.type).name
    }

    selectType(typeData:NodeInsightsTypeData, i:number) {
        if (this.selectedType === typeData) {
            this.selectedType = undefined
            this.selectedIndex = undefined
        }else {
            this.selectedType = typeData
            this.selectedIndex = i
        }

        this.selectTypeEvent.emit(this.selectedType)
    }
}
